"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ctxExtendResolveProduct;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _isString = _interopRequireDefault(require("lodash/fp/isString"));

var _isPlainObject = _interopRequireDefault(require("lodash/fp/isPlainObject"));

/**
 * Creates
 * @param {*} productFinder
 */
function ctxExtendResolveProduct(ctx) {
  var findProduct = (ctx || {}).productFinder || function () {
    return Promise.resolve(null);
  };

  var createPlaceholder = function createPlaceholder(val) {
    return val;
  }; // TODO: can we have placeholder like this: `({ id: val, sku: val });`?


  var ensureProduct = function ensureProduct(can) {
    return function (pr) {
      return (0, _isPlainObject.default)(pr) ? pr : createPlaceholder(can);
    };
  };
  /**
   * Returns product object.
   *
   * @param {string | Object} productCandidate
   */


  return (0, _extends2.default)({}, ctx, {
    resolveProduct: function resolveProduct(productCandidate) {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (0, _cond.default)([[_isString.default, function (can) {
                  return findProduct(can).then(ensureProduct(can)).catch(function () {
                    return ensureProduct(can)(null);
                  });
                }], [_isPlainObject.default, function (can) {
                  return can;
                }], [function () {
                  return true;
                }, function () {
                  return null;
                }]])(productCandidate));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  });
}